import { useParams, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { LabContext } from "../../context/labContext";
import Loading from "../../components/Loading";
import Carging from "../../components/Carging";
import RenderIf from "../../components/RenderIf";

const Lab = () => {
    const { id } = useParams();
    const { getLabById, saveLab, deleteLab } = useContext(LabContext);

    const [lab, setLab] = useState(null);
    const [saveing, setSaveing] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const navigate = useNavigate();


    useEffect(() => {
        if (id) {
            getLabById(id)
                .then(res => {
                    setLab(res);
                })
                .catch(err => {
                    setLab(false);
                });

        } else {
            setLab({
                title: "",
                description: "",
                url: "",
                type : "",
            });
        }
    }, [id])

    if (lab === null) {
        return <Carging />
    }

    if (lab === false) {
        return <div>No se encontraron detalles</div>
    }

    const handleChange = (e) => {
        setLab({
            ...lab,
            [e.target.id]: e.target.value
        })


    }

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(lab);
        setSaveing(true);
        saveLab(lab)
            .then(res => {
                setSaveing(false);
            })
    }

    const handleDelete = (id) => {

        deleteLab(id)
            .then(res => {
                setLab(false);
                navigate("/admin/lab");
            })
            .catch(err => {
                console.log(err)
            });
    }

    return (
        <div className="h-100 w-100" >
            <div className="col-12 d-flex">
                <form className="col-12" onSubmit={(e) => handleSubmit(e)}>
                    <div className="form-floating">
                        <input
                            onChange={(e) => handleChange(e)}
                            type="text"
                            className="form-control mb-3"
                            id="title"
                            value={lab.title} />
                        <label htmlFor="title" className="form-label">Title</label>
                    </div>

                    <div className="form-floating mb-3">
                        <textarea
                            onChange={(e) => handleChange(e)}
                            className="form-control"
                            id="description"
                            value={lab.description}
                        />
                        <label htmlFor="Description" className="form-label">Description</label>
                    </div>

                    <div className="form-floating mb-3">
                        <select className="form-select"
                            onChange={(e) => handleChange(e)}
                            value={lab.type}

                            id="type"
                            aria-label="Floating label select example"
                        >
                            <option value selected={!lab.type ? true : false}>Open this select menu</option>
                            <option value="video" selected={lab.type === 'video' ? true : false}>video</option>
                            <option value="article" selected={lab.type === 'article' ? true : false}>article</option>
                            <option value="code" selected={lab.type === null ? true : false}>code</option>
                        </select>
                        <label htmlFor="type">Select</label>
                    </div>

                    <div className="form-floating mb-3">
                        <input
                            onChange={(e) => handleChange(e)}
                            type="text"
                            className="form-control"
                            id="url"
                            value={lab.url}
                        />
                        <label htmlFor="Url" className="form-label">Viedo Id</label>
                    </div>
                    
                    <div className="d-flex justify-content-end">
                        <RenderIf condition={id}>
                            <button
                                onClick={() => handleDelete(id)}
                                type="button"
                                className="btn btn-defult mr-3">
                                <i className="bi bi-trash"></i>
                                {deleting ? <Carging /> : 'Delete'}
                            </button>
                        </RenderIf>

                        <button
                            type="submit"
                            className="btn btn-primary">
                            {saveing ? <Carging /> : 'Save'}

                        </button>
                    </div>
                </form>
            </div>
        </div>
    )

}

export default Lab;